import List from "@/components/list";
import vue from "@/main";

const Table = args => {
  function finishContact(item) {
    vue.$emit("contacted", item);
  }

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const contacted = item.contactStatus == 1;
    return (
      <div class="deal-group">
        {contacted ? (
          <span>{item.contactStatusName}</span>
        ) : (
          <el-tooltip
            effect="dark"
            content={item.contactStatusName}
            v-permission="lessonApply:contact"
            placement="top"
          >
            <i
              class="el-icon-circle-check"
              style="font-size: 20px"
              onClick={() => finishContact(item)}
            ></i>
          </el-tooltip>
        )}
      </div>
    );
  };
  const AccountTableConfig = [
    {
      label: "申请人姓名",
      prop: "applyUserName",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "联系方式",
      prop: "contact",
      minWidth: "120",
      showOverflowTooltip: true
    },
    {
      label: "申请类型",
      prop: "applyTypeName",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "申请时间",
      prop: "createDate",
      minWidth: "150"
    },
    {
      label: "申请内容",
      prop: "applyContent",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "联系记录",
      prop: "contactRecord",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "联系情况",
      minWidth: "120",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};
export default Table;
